import React from "react";
import { useParams } from "react-router-dom";
import Support from "../components/support";

const Error = () => {
    const { error } = useParams();
    if (error === "401") {
        return <div>Unauthorized access
            <Support />
        </div>;
    }
    return <div>Error: {error}
        <Support />
    </div>;
};

export default Error;
